const PAISES = {
  AFG: {
    pais_id: 'AFG',
    pais: 'Afeganistão',
    pais_ingles: 'Afghanistan',
    ddi: 93,
    moeda: 'AFN',
    moeda_nome: 'Afghani',
    moeda_simbolo: 'Ø‹',
    sigla_iso: 'AF',
    sigla_idioma: null,
    sigla_fifa: 'AFG',
    tld: '.af',
    continente: 'AS'
  },
  ZAF: {
    pais_id: 'ZAF',
    pais: 'África do Sul',
    pais_ingles: 'South Africa',
    ddi: 27,
    moeda: 'ZAR',
    moeda_nome: 'Rand',
    moeda_simbolo: 'R',
    sigla_iso: 'ZA',
    sigla_idioma: 'EN',
    sigla_fifa: 'RSA',
    tld: '.za',
    continente: 'AF'
  },
  ALA: {
    pais_id: 'ALA',
    pais: 'Aland Islands',
    pais_ingles: 'Aland Islands',
    ddi: null,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: 'T',
    sigla_iso: 'AX',
    sigla_idioma: null,
    sigla_fifa: 'ALD',
    tld: '.ax',
    continente: 'EU'
  },
  ALB: {
    pais_id: 'ALB',
    pais: 'Albania',
    pais_ingles: 'Albania',
    ddi: 355,
    moeda: 'ALL',
    moeda_nome: 'Lek',
    moeda_simbolo: 'L',
    sigla_iso: 'AL',
    sigla_idioma: 'SQ',
    sigla_fifa: 'ALB',
    tld: '.al',
    continente: 'EU'
  },
  DEU: {
    pais_id: 'DEU',
    pais: 'Alemanha',
    pais_ingles: 'Germany',
    ddi: 49,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'DE',
    sigla_idioma: 'DE',
    sigla_fifa: 'GER',
    tld: '.de',
    continente: 'EU'
  },
  AND: {
    pais_id: 'AND',
    pais: 'Andorra',
    pais_ingles: 'Andorra',
    ddi: 376,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'AD',
    sigla_idioma: 'CA',
    sigla_fifa: 'AND',
    tld: '.ad',
    continente: 'EU'
  },
  AGO: {
    pais_id: 'AGO',
    pais: 'Angola',
    pais_ingles: 'Angola',
    ddi: 244,
    moeda: 'AOA',
    moeda_nome: 'Kwanza',
    moeda_simbolo: 'Kz',
    sigla_iso: 'AO',
    sigla_idioma: 'PT',
    sigla_fifa: 'ANG',
    tld: '.ao',
    continente: 'AF'
  },
  AIA: {
    pais_id: 'AIA',
    pais: 'Anguilla',
    pais_ingles: 'Anguilla',
    ddi: 1264,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental ',
    moeda_simbolo: '$',
    sigla_iso: 'AI',
    sigla_idioma: null,
    sigla_fifa: 'AIA',
    tld: '.ai',
    continente: 'NA'
  },
  ATA: {
    pais_id: 'ATA',
    pais: 'Antártida',
    pais_ingles: 'Antarctica',
    ddi: 672,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'AQ',
    sigla_idioma: null,
    sigla_fifa: 'ROS',
    tld: '.aq',
    continente: 'AN'
  },
  ATG: {
    pais_id: 'ATG',
    pais: 'Antígua e Barbuda',
    pais_ingles: 'Antigua and Barbuda',
    ddi: 1268,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'AG',
    sigla_idioma: null,
    sigla_fifa: 'ATG',
    tld: '.ag',
    continente: 'NA'
  },
  SAU: {
    pais_id: 'SAU',
    pais: 'Arabia Saudita',
    pais_ingles: 'Saudi Arabia',
    ddi: 966,
    moeda: 'SAR',
    moeda_nome: 'Rial',
    moeda_simbolo: '﷼',
    sigla_iso: 'SA',
    sigla_idioma: 'AR',
    sigla_fifa: 'KSA',
    tld: '.sa',
    continente: 'AS'
  },
  DZA: {
    pais_id: 'DZA',
    pais: 'Argélia',
    pais_ingles: 'Algeria',
    ddi: 213,
    moeda: 'DZD',
    moeda_nome: 'Dinar Argelino',
    moeda_simbolo: 'DA',
    sigla_iso: 'DZ',
    sigla_idioma: 'ES',
    sigla_fifa: 'ALG',
    tld: '.dz',
    continente: 'AF'
  },
  ARG: {
    pais_id: 'ARG',
    pais: 'Argentina',
    pais_ingles: 'Argentina',
    ddi: 54,
    moeda: 'ARS',
    moeda_nome: 'Argentine Peso',
    moeda_simbolo: '$',
    sigla_iso: 'AR',
    sigla_idioma: 'ES',
    sigla_fifa: 'ARG',
    tld: '.ar',
    continente: 'SA'
  },
  ARM: {
    pais_id: 'ARM',
    pais: 'Armênia',
    pais_ingles: 'Armenia',
    ddi: 374,
    moeda: 'AMD',
    moeda_nome: 'Armenian Dram',
    moeda_simbolo: null,
    sigla_iso: 'AM',
    sigla_idioma: 'RU',
    sigla_fifa: 'ARM',
    tld: '.am',
    continente: 'AS'
  },
  ABW: {
    pais_id: 'ABW',
    pais: 'Aruba',
    pais_ingles: 'Aruba',
    ddi: 297,
    moeda: 'AWG',
    moeda_nome: 'Florim - Aruba',
    moeda_simbolo: 'Æ’',
    sigla_iso: 'AW',
    sigla_idioma: null,
    sigla_fifa: 'ARU',
    tld: '.aw',
    continente: 'NA'
  },
  AUS: {
    pais_id: 'AUS',
    pais: 'Austrália',
    pais_ingles: 'Australian',
    ddi: 61,
    moeda: 'AUD',
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'AU',
    sigla_idioma: null,
    sigla_fifa: 'AUS',
    tld: '.au',
    continente: 'OC'
  },
  AUT: {
    pais_id: 'AUT',
    pais: 'Áustria',
    pais_ingles: 'Austria',
    ddi: 43,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'AT',
    sigla_idioma: 'DE',
    sigla_fifa: 'AUT',
    tld: '.at',
    continente: 'EU'
  },
  AZE: {
    pais_id: 'AZE',
    pais: 'Azerbaijão',
    pais_ingles: 'Azerbaijan',
    ddi: 994,
    moeda: 'AZN',
    moeda_nome: 'Azerbaijanian Manat',
    moeda_simbolo: null,
    sigla_iso: 'AZ',
    sigla_idioma: 'RU',
    sigla_fifa: 'AZE',
    tld: '.az',
    continente: 'AS'
  },
  BHS: {
    pais_id: 'BHS',
    pais: 'Bahamas',
    pais_ingles: 'Bahamas',
    ddi: 1242,
    moeda: null,
    moeda_nome: 'Bahamian Dollar',
    moeda_simbolo: null,
    sigla_iso: 'BS',
    sigla_idioma: null,
    sigla_fifa: 'BAH',
    tld: '.bs',
    continente: 'NA'
  },
  BHR: {
    pais_id: 'BHR',
    pais: 'Bahrain',
    pais_ingles: 'Bahrain',
    ddi: 973,
    moeda: 'BHD',
    moeda_nome: 'Bahraini Dinar',
    moeda_simbolo: 'BD',
    sigla_iso: 'BH',
    sigla_idioma: 'AR',
    sigla_fifa: 'BHR',
    tld: '.bh',
    continente: 'AS'
  },
  BGD: {
    pais_id: 'BGD',
    pais: 'Bangladesh',
    pais_ingles: 'Bangladesh',
    ddi: 880,
    moeda: 'BDT',
    moeda_nome: 'Taka',
    moeda_simbolo: '৳',
    sigla_iso: 'BD',
    sigla_idioma: 'BN',
    sigla_fifa: 'BAN',
    tld: '.bd',
    continente: 'AS'
  },
  BRB: {
    pais_id: 'BRB',
    pais: 'Barbados',
    pais_ingles: 'Barbados',
    ddi: 1246,
    moeda: 'BBD',
    moeda_nome: 'Barbados Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'BB',
    sigla_idioma: null,
    sigla_fifa: 'BRB',
    tld: '.bb',
    continente: 'NA'
  },
  BLR: {
    pais_id: 'BLR',
    pais: 'Belarus',
    pais_ingles: 'Belarus',
    ddi: 375,
    moeda: 'BYR',
    moeda_nome: 'Belarussian Ruble',
    moeda_simbolo: 'Br',
    sigla_iso: 'BY',
    sigla_idioma: 'RU',
    sigla_fifa: 'BLR',
    tld: '.by',
    continente: 'EU'
  },
  BEL: {
    pais_id: 'BEL',
    pais: 'Bélgica',
    pais_ingles: 'Belgium',
    ddi: 32,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'BE',
    sigla_idioma: 'FR',
    sigla_fifa: 'BEL',
    tld: '.be',
    continente: 'EU'
  },
  BLZ: {
    pais_id: 'BLZ',
    pais: 'Belize',
    pais_ingles: 'Belize',
    ddi: 501,
    moeda: 'BZD',
    moeda_nome: 'Dolar - Belize',
    moeda_simbolo: '$',
    sigla_iso: 'BZ',
    sigla_idioma: 'EN',
    sigla_fifa: 'BLZ',
    tld: '.bz',
    continente: 'NA'
  },
  BEN: {
    pais_id: 'BEN',
    pais: 'Benin',
    pais_ingles: 'Benin',
    ddi: 229,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'BJ',
    sigla_idioma: 'EN',
    sigla_fifa: 'BEN',
    tld: '.bj',
    continente: 'AF'
  },
  BMU: {
    pais_id: 'BMU',
    pais: 'Bermuda',
    pais_ingles: 'Bermuda',
    ddi: 1441,
    moeda: 'BMD',
    moeda_nome: 'Bermudian Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'BM',
    sigla_idioma: null,
    sigla_fifa: 'BER',
    tld: '.bm',
    continente: 'NA'
  },
  BOL: {
    pais_id: 'BOL',
    pais: 'Bolivia',
    pais_ingles: 'Bolivia',
    ddi: 591,
    moeda: 'BOB',
    moeda_nome: 'Boliviano',
    moeda_simbolo: 'Bs.',
    sigla_iso: 'BO',
    sigla_idioma: 'ES',
    sigla_fifa: 'BOL',
    tld: '.bo',
    continente: 'SA'
  },
  BIH: {
    pais_id: 'BIH',
    pais: 'Bósnia e Herzegovina',
    pais_ingles: 'Bosnia and Herzegovina',
    ddi: 387,
    moeda: 'BAM',
    moeda_nome: 'Convertible Mark',
    moeda_simbolo: 'KM or ÐšÐœ',
    sigla_iso: 'BA',
    sigla_idioma: null,
    sigla_fifa: 'BIH',
    tld: '.ba',
    continente: 'EU'
  },
  BWA: {
    pais_id: 'BWA',
    pais: 'Botswana',
    pais_ingles: 'Botswana',
    ddi: 267,
    moeda: 'BWP',
    moeda_nome: 'Pula',
    moeda_simbolo: 'P',
    sigla_iso: 'BW',
    sigla_idioma: 'EN',
    sigla_fifa: 'BOT',
    tld: '.bw',
    continente: 'AF'
  },
  BVT: {
    pais_id: 'BVT',
    pais: 'Bouvet Island',
    pais_ingles: 'Bouvet Island',
    ddi: null,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'BV',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.bv',
    continente: 'AN'
  },
  BRA: {
    pais_id: 'BRA',
    pais: 'Brasil',
    pais_ingles: 'Brazil',
    ddi: 55,
    moeda: 'BRL',
    moeda_nome: 'Real',
    moeda_simbolo: 'R$',
    sigla_iso: 'BR',
    sigla_idioma: 'PT',
    sigla_fifa: 'BRA',
    tld: '.br',
    continente: 'SA'
  },
  BRN: {
    pais_id: 'BRN',
    pais: 'Brunei Darussalam',
    pais_ingles: 'Brunei Darussalam',
    ddi: 673,
    moeda: 'BND',
    moeda_nome: 'Brunei Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'BN',
    sigla_idioma: 'MS',
    sigla_fifa: 'BRU',
    tld: '.bn',
    continente: 'AS'
  },
  BGR: {
    pais_id: 'BGR',
    pais: 'Bulgaria',
    pais_ingles: 'Bulgaria',
    ddi: 359,
    moeda: 'BGN',
    moeda_nome: 'Bulgarian Lev',
    moeda_simbolo: 'лв',
    sigla_iso: 'BG',
    sigla_idioma: 'BG',
    sigla_fifa: 'BUL',
    tld: '.bg',
    continente: 'EU'
  },
  BFA: {
    pais_id: 'BFA',
    pais: 'Burkina Faso',
    pais_ingles: 'Burkina Faso',
    ddi: 226,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'BF',
    sigla_idioma: null,
    sigla_fifa: 'BFA',
    tld: '.bf',
    continente: 'AF'
  },
  BDI: {
    pais_id: 'BDI',
    pais: 'Burundi',
    pais_ingles: 'Burundi',
    ddi: 257,
    moeda: 'BIF',
    moeda_nome: 'Burundi Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'BI',
    sigla_idioma: 'FR',
    sigla_fifa: 'BDI',
    tld: '.bi',
    continente: 'AF'
  },
  BTN: {
    pais_id: 'BTN',
    pais: 'Butão',
    pais_ingles: 'Bhutan',
    ddi: 975,
    moeda: 'BTN',
    moeda_nome: 'Indian Rupee',
    moeda_simbolo: 'Nu.',
    sigla_iso: 'BT',
    sigla_idioma: 'DZ',
    sigla_fifa: 'BHU',
    tld: '.bt',
    continente: 'AS'
  },
  CPV: {
    pais_id: 'CPV',
    pais: 'Cabo Verde',
    pais_ingles: 'Cape Verde',
    ddi: 238,
    moeda: 'CVE',
    moeda_nome: 'Cabo Verde Escudo',
    moeda_simbolo: 'Esc or $',
    sigla_iso: 'CV',
    sigla_idioma: 'PT',
    sigla_fifa: 'CPV',
    tld: '.cv',
    continente: 'AF'
  },
  CMR: {
    pais_id: 'CMR',
    pais: 'Camarões',
    pais_ingles: 'Cameroon',
    ddi: 237,
    moeda: 'XAF',
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: 'Fr',
    sigla_iso: 'CM',
    sigla_idioma: 'EN',
    sigla_fifa: 'CMR',
    tld: '.cm',
    continente: 'AF'
  },
  KHM: {
    pais_id: 'KHM',
    pais: 'Cambodja',
    pais_ingles: 'Cambodia',
    ddi: 855,
    moeda: 'KHR',
    moeda_nome: 'Riel',
    moeda_simbolo: '៛',
    sigla_iso: 'KH',
    sigla_idioma: null,
    sigla_fifa: 'CAM',
    tld: '.kh',
    continente: 'AS'
  },
  CAN: {
    pais_id: 'CAN',
    pais: 'Canada',
    pais_ingles: 'Canada',
    ddi: 1,
    moeda: 'CAD',
    moeda_nome: 'Canadian Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'CA',
    sigla_idioma: null,
    sigla_fifa: 'CAN',
    tld: '.ca',
    continente: 'NA'
  },
  KAZ: {
    pais_id: 'KAZ',
    pais: 'Cazaquistão',
    pais_ingles: 'Kazakhstan',
    ddi: 7,
    moeda: 'KZT',
    moeda_nome: 'Tenge',
    moeda_simbolo: null,
    sigla_iso: 'KZ',
    sigla_idioma: 'RU',
    sigla_fifa: 'KAZ',
    tld: '.kz',
    continente: 'AS'
  },
  CAF: {
    pais_id: 'CAF',
    pais: 'Central African Republic',
    pais_ingles: 'Central African Republic',
    ddi: 236,
    moeda: 'XAF',
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: 'Fr',
    sigla_iso: 'CF',
    sigla_idioma: null,
    sigla_fifa: 'CTA',
    tld: '.cf',
    continente: 'AF'
  },
  TCD: {
    pais_id: 'TCD',
    pais: 'Chad',
    pais_ingles: 'Chad',
    ddi: 235,
    moeda: 'XAF',
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: 'Fr',
    sigla_iso: 'TD',
    sigla_idioma: 'FR',
    sigla_fifa: 'CHA',
    tld: '.td',
    continente: 'AF'
  },
  CHL: {
    pais_id: 'CHL',
    pais: 'Chile',
    pais_ingles: 'Chile',
    ddi: 56,
    moeda: 'CLP',
    moeda_nome: 'Chilean Peso',
    moeda_simbolo: '$',
    sigla_iso: 'CL',
    sigla_idioma: 'ES',
    sigla_fifa: 'CHI',
    tld: '.cl',
    continente: 'SA'
  },
  CHN: {
    pais_id: 'CHN',
    pais: 'China',
    pais_ingles: 'China',
    ddi: 86,
    moeda: 'CNY',
    moeda_nome: 'Yuan Renminbi',
    moeda_simbolo: '¥',
    sigla_iso: 'CN',
    sigla_idioma: 'ZH',
    sigla_fifa: 'CHN',
    tld: '.cn',
    continente: 'AS'
  },
  CYP: {
    pais_id: 'CYP',
    pais: 'Chipre',
    pais_ingles: 'Cyprus',
    ddi: 357,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'CY',
    sigla_idioma: 'EL',
    sigla_fifa: 'CYP',
    tld: '.cy',
    continente: 'EU'
  },
  COL: {
    pais_id: 'COL',
    pais: 'Colômbia',
    pais_ingles: 'Colombia',
    ddi: 57,
    moeda: 'COP',
    moeda_nome: 'Colombian Peso',
    moeda_simbolo: '$',
    sigla_iso: 'CO',
    sigla_idioma: 'EN',
    sigla_fifa: 'COL',
    tld: '.co',
    continente: 'SA'
  },
  COM: {
    pais_id: 'COM',
    pais: 'Comores',
    pais_ingles: 'Comoros',
    ddi: 269,
    moeda: 'KMF',
    moeda_nome: 'Comoro Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'KM',
    sigla_idioma: null,
    sigla_fifa: 'COM',
    tld: '.km',
    continente: 'AF'
  },
  COG: {
    pais_id: 'COG',
    pais: 'Congo Republic of the Democratic',
    pais_ingles: 'Congo Republic of the Democratic',
    ddi: null,
    moeda: null,
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: null,
    sigla_iso: 'CG',
    sigla_idioma: null,
    sigla_fifa: 'CGO',
    tld: '.cg',
    continente: 'AF'
  },
  COD: {
    pais_id: 'COD',
    pais: 'Congo-Brazzaville',
    pais_ingles: 'Congo-Brazzaville',
    ddi: 242,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'CD',
    sigla_idioma: 'FR',
    sigla_fifa: 'COD',
    tld: '.cd',
    continente: 'AF'
  },
  PRK: {
    pais_id: 'PRK',
    pais: 'Coreia do Norte',
    pais_ingles: 'Korea North',
    ddi: 850,
    moeda: null,
    moeda_nome: 'North Korean Won',
    moeda_simbolo: null,
    sigla_iso: 'KP',
    sigla_idioma: 'KO',
    sigla_fifa: 'PRK',
    tld: '.kp',
    continente: 'AS'
  },
  KOR: {
    pais_id: 'KOR',
    pais: 'Coreia do Sul',
    pais_ingles: 'Korea South',
    ddi: 82,
    moeda: null,
    moeda_nome: 'Won',
    moeda_simbolo: null,
    sigla_iso: 'KR',
    sigla_idioma: 'KO',
    sigla_fifa: 'KOR',
    tld: '.kr',
    continente: 'AS'
  },
  CIV: {
    pais_id: 'CIV',
    pais: 'Costa do Marfim',
    pais_ingles: 'Ivory Coast',
    ddi: 225,
    moeda: null,
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: null,
    sigla_iso: 'CI',
    sigla_idioma: 'FR',
    sigla_fifa: 'CIV',
    tld: '.ci',
    continente: 'AF'
  },
  CRI: {
    pais_id: 'CRI',
    pais: 'Costa Rica',
    pais_ingles: 'Costa Rica',
    ddi: 506,
    moeda: 'CRC',
    moeda_nome: 'Costa Rican Colon',
    moeda_simbolo: '₡',
    sigla_iso: 'CR',
    sigla_idioma: 'ES',
    sigla_fifa: 'CRC',
    tld: '.cr',
    continente: 'NA'
  },
  HRV: {
    pais_id: 'HRV',
    pais: 'Croácia',
    pais_ingles: 'Croatia (Hrvatska)',
    ddi: 385,
    moeda: null,
    moeda_nome: 'Croatian Kuna',
    moeda_simbolo: null,
    sigla_iso: 'HR',
    sigla_idioma: 'EN',
    sigla_fifa: 'CRO',
    tld: '.hr',
    continente: 'EU'
  },
  CUB: {
    pais_id: 'CUB',
    pais: 'Cuba',
    pais_ingles: 'Cuba',
    ddi: 53,
    moeda: 'CUC',
    moeda_nome: 'Cuban Peso',
    moeda_simbolo: '$',
    sigla_iso: 'CU',
    sigla_idioma: 'ES',
    sigla_fifa: 'CUB',
    tld: '.cu',
    continente: 'NA'
  },
  DNK: {
    pais_id: 'DNK',
    pais: 'Dinamarca',
    pais_ingles: 'Denmark',
    ddi: 45,
    moeda: 'DKK',
    moeda_nome: 'Danish Krone',
    moeda_simbolo: 'kr',
    sigla_iso: 'DK',
    sigla_idioma: 'DA',
    sigla_fifa: 'DEN',
    tld: '.dk',
    continente: 'EU'
  },
  DJI: {
    pais_id: 'DJI',
    pais: 'Djibouti',
    pais_ingles: 'Djibouti',
    ddi: 253,
    moeda: 'DJF',
    moeda_nome: 'Djibouti Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'DJ',
    sigla_idioma: 'EN',
    sigla_fifa: 'DJI',
    tld: '.dj',
    continente: 'AF'
  },
  DMA: {
    pais_id: 'DMA',
    pais: 'Dominica',
    pais_ingles: 'Dominica',
    ddi: 767,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'DM',
    sigla_idioma: null,
    sigla_fifa: 'DMA',
    tld: '.dm',
    continente: 'NA'
  },
  EGY: {
    pais_id: 'EGY',
    pais: 'Egito',
    pais_ingles: 'Egypt',
    ddi: 20,
    moeda: 'EGP',
    moeda_nome: 'Egyptian Pound',
    moeda_simbolo: '£',
    sigla_iso: 'EG',
    sigla_idioma: 'AR',
    sigla_fifa: 'EGY',
    tld: '.eg',
    continente: 'AF'
  },
  SLV: {
    pais_id: 'SLV',
    pais: 'El Salvador',
    pais_ingles: 'El Salvador',
    ddi: 503,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'SV',
    sigla_idioma: 'ES',
    sigla_fifa: 'SLV',
    tld: '.sv',
    continente: 'NA'
  },
  ARE: {
    pais_id: 'ARE',
    pais: 'Emirados Árabes Unidos',
    pais_ingles: 'United Arab Emirates',
    ddi: 971,
    moeda: 'AED',
    moeda_nome: 'UAE Dirham',
    moeda_simbolo: 'DH',
    sigla_iso: 'AE',
    sigla_idioma: null,
    sigla_fifa: 'UAE',
    tld: '.ae',
    continente: 'AS'
  },
  ECU: {
    pais_id: 'ECU',
    pais: 'Equador',
    pais_ingles: 'Ecuador',
    ddi: 593,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'EC',
    sigla_idioma: 'ES',
    sigla_fifa: 'ECU',
    tld: '.ec',
    continente: 'SA'
  },
  GNQ: {
    pais_id: 'GNQ',
    pais: 'Equatorial Guinea',
    pais_ingles: 'Equatorial Guinea',
    ddi: 240,
    moeda: 'XAF',
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: 'Fr',
    sigla_iso: 'GQ',
    sigla_idioma: 'EN',
    sigla_fifa: 'EQG',
    tld: '.gq',
    continente: 'AF'
  },
  ERI: {
    pais_id: 'ERI',
    pais: 'Eritrea',
    pais_ingles: 'Eritrea',
    ddi: 291,
    moeda: 'ERN',
    moeda_nome: 'Nakfa',
    moeda_simbolo: 'Nfk',
    sigla_iso: 'ER',
    sigla_idioma: 'AR',
    sigla_fifa: 'ERI',
    tld: '.er',
    continente: 'AF'
  },
  SVK: {
    pais_id: 'SVK',
    pais: 'Eslováquia',
    pais_ingles: 'Slovakia (Slovak Republic)',
    ddi: 421,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'SK',
    sigla_idioma: null,
    sigla_fifa: 'SVK',
    tld: '.sk',
    continente: 'EU'
  },
  SVN: {
    pais_id: 'SVN',
    pais: 'Eslovênia',
    pais_ingles: 'Slovenia',
    ddi: 386,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'SI',
    sigla_idioma: 'EN',
    sigla_fifa: 'SVN',
    tld: '.si',
    continente: 'EU'
  },
  ESP: {
    pais_id: 'ESP',
    pais: 'Espanha',
    pais_ingles: 'Spain',
    ddi: 34,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'ES',
    sigla_idioma: 'ES',
    sigla_fifa: 'ESP',
    tld: '.es',
    continente: 'EU'
  },
  USA: {
    pais_id: 'USA',
    pais: 'Estados Unidos da America',
    pais_ingles: 'United States',
    ddi: null,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'US',
    sigla_idioma: null,
    sigla_fifa: 'USA',
    tld: '.us',
    continente: 'NA'
  },
  EST: {
    pais_id: 'EST',
    pais: 'Estônia',
    pais_ingles: 'Estonia',
    ddi: 372,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'EE',
    sigla_idioma: 'RU',
    sigla_fifa: 'EST',
    tld: '.ee',
    continente: 'EU'
  },
  ETH: {
    pais_id: 'ETH',
    pais: 'Etiópia',
    pais_ingles: 'Ethiopia',
    ddi: 251,
    moeda: 'ETB',
    moeda_nome: 'Ethiopian Birr',
    moeda_simbolo: 'Br',
    sigla_iso: 'ET',
    sigla_idioma: 'AM',
    sigla_fifa: 'ETH',
    tld: '.et',
    continente: 'AF'
  },
  FLK: {
    pais_id: 'FLK',
    pais: 'Falkland Islands (Malvinas)',
    pais_ingles: 'Falkland Islands (Malvinas)',
    ddi: 500,
    moeda: 'FKP',
    moeda_nome: 'Falkland Islands Pound',
    moeda_simbolo: '₤',
    sigla_iso: 'FK',
    sigla_idioma: null,
    sigla_fifa: 'FLK',
    tld: '.fk',
    continente: 'SA'
  },
  FRO: {
    pais_id: 'FRO',
    pais: 'Faroe Islands',
    pais_ingles: 'Faroe Islands',
    ddi: 298,
    moeda: 'DKK',
    moeda_nome: 'Danish krone',
    moeda_simbolo: 'kr',
    sigla_iso: 'FO',
    sigla_idioma: null,
    sigla_fifa: 'FRO',
    tld: '.fo',
    continente: 'EU'
  },
  FJI: {
    pais_id: 'FJI',
    pais: 'Fiji',
    pais_ingles: 'Fiji',
    ddi: 679,
    moeda: null,
    moeda_nome: 'Fiji Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'FJ',
    sigla_idioma: 'EN',
    sigla_fifa: 'FIJ',
    tld: '.fj',
    continente: 'OC'
  },
  PHL: {
    pais_id: 'PHL',
    pais: 'Filipinas',
    pais_ingles: 'Philippines',
    ddi: 63,
    moeda: 'PHP',
    moeda_nome: 'Philippine Peso',
    moeda_simbolo: '₱',
    sigla_iso: 'PH',
    sigla_idioma: 'FL',
    sigla_fifa: 'PHI',
    tld: '.ph',
    continente: 'AS'
  },
  FIN: {
    pais_id: 'FIN',
    pais: 'Finlândia',
    pais_ingles: 'Finland',
    ddi: 358,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'FI',
    sigla_idioma: 'EN',
    sigla_fifa: 'FIN',
    tld: '.fi',
    continente: 'EU'
  },
  FRA: {
    pais_id: 'FRA',
    pais: 'França',
    pais_ingles: 'France',
    ddi: 33,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'FR',
    sigla_idioma: 'FR',
    sigla_fifa: 'FRA',
    tld: '.fr',
    continente: 'EU'
  },
  ATF: {
    pais_id: 'ATF',
    pais: 'French Southern Territories',
    pais_ingles: 'French Southern Territories',
    ddi: 262,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'TF',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.tf',
    continente: 'AN'
  },
  GAB: {
    pais_id: 'GAB',
    pais: 'Gabon',
    pais_ingles: 'Gabon',
    ddi: 241,
    moeda: 'XAF',
    moeda_nome: 'CFA Franc BEAC',
    moeda_simbolo: 'Fr',
    sigla_iso: 'GA',
    sigla_idioma: 'FR',
    sigla_fifa: 'GAB',
    tld: '.ga',
    continente: 'AF'
  },
  GMB: {
    pais_id: 'GMB',
    pais: 'Gambia',
    pais_ingles: 'Gambia',
    ddi: 220,
    moeda: null,
    moeda_nome: 'Dalasi',
    moeda_simbolo: null,
    sigla_iso: 'GM',
    sigla_idioma: 'EN',
    sigla_fifa: 'GAM',
    tld: '.gm',
    continente: 'AF'
  },
  GEO: {
    pais_id: 'GEO',
    pais: 'Georgia',
    pais_ingles: 'Georgia',
    ddi: 995,
    moeda: 'GEL',
    moeda_nome: 'Lari',
    moeda_simbolo: '₾',
    sigla_iso: 'GE',
    sigla_idioma: 'RU',
    sigla_fifa: 'GEO',
    tld: '.ge',
    continente: 'AS'
  },
  GHA: {
    pais_id: 'GHA',
    pais: 'Ghana',
    pais_ingles: 'Ghana',
    ddi: 233,
    moeda: 'GHS',
    moeda_nome: 'Ghana Cedi',
    moeda_simbolo: 'GH¢',
    sigla_iso: 'GH',
    sigla_idioma: 'EN',
    sigla_fifa: 'GHA',
    tld: '.gh',
    continente: 'AF'
  },
  GIB: {
    pais_id: 'GIB',
    pais: 'Gibraltar',
    pais_ingles: 'Gibraltar',
    ddi: 350,
    moeda: 'GIP',
    moeda_nome: 'Gibraltar Pound',
    moeda_simbolo: '₤',
    sigla_iso: 'GI',
    sigla_idioma: 'EN',
    sigla_fifa: 'GBZ',
    tld: '.gi',
    continente: 'EU'
  },
  GRD: {
    pais_id: 'GRD',
    pais: 'Granada',
    pais_ingles: 'Grenada',
    ddi: 1473,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'GD',
    sigla_idioma: null,
    sigla_fifa: 'GRN',
    tld: '.gd',
    continente: 'NA'
  },
  GRC: {
    pais_id: 'GRC',
    pais: 'Grécia',
    pais_ingles: 'Greece',
    ddi: 30,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'GR',
    sigla_idioma: 'EL',
    sigla_fifa: 'GRE',
    tld: '.gr',
    continente: 'EU'
  },
  GRL: {
    pais_id: 'GRL',
    pais: 'Groenlândia',
    pais_ingles: 'Greenland',
    ddi: 299,
    moeda: null,
    moeda_nome: 'Danish Krone',
    moeda_simbolo: null,
    sigla_iso: 'GL',
    sigla_idioma: 'EN',
    sigla_fifa: 'GRL',
    tld: '.gl',
    continente: 'NA'
  },
  GLP: {
    pais_id: 'GLP',
    pais: 'Guadalupe',
    pais_ingles: 'Guadeloupe',
    ddi: 590,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'GP',
    sigla_idioma: 'FR',
    sigla_fifa: 'GLP',
    tld: '.gp',
    continente: 'NA'
  },
  GUM: {
    pais_id: 'GUM',
    pais: 'Guam',
    pais_ingles: 'Guam',
    ddi: 1,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'GU',
    sigla_idioma: null,
    sigla_fifa: 'GUM',
    tld: '.gu',
    continente: 'OC'
  },
  GTM: {
    pais_id: 'GTM',
    pais: 'Guatemala',
    pais_ingles: 'Guatemala',
    ddi: 502,
    moeda: 'GTQ',
    moeda_nome: 'Quetzal',
    moeda_simbolo: 'Q',
    sigla_iso: 'GT',
    sigla_idioma: 'ES',
    sigla_fifa: 'GUA',
    tld: '.gt',
    continente: 'NA'
  },
  GGY: {
    pais_id: 'GGY',
    pais: 'Guernsey',
    pais_ingles: 'Guernsey',
    ddi: 44,
    moeda: 'GGP',
    moeda_nome: 'Pound Sterling',
    moeda_simbolo: '₤',
    sigla_iso: 'GG',
    sigla_idioma: null,
    sigla_fifa: 'GBG',
    tld: '.gg',
    continente: 'EU'
  },
  GUY: {
    pais_id: 'GUY',
    pais: 'Guiana',
    pais_ingles: 'Guyana',
    ddi: 592,
    moeda: 'GYD',
    moeda_nome: 'Guyana Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'GY',
    sigla_idioma: 'EN',
    sigla_fifa: 'GUY',
    tld: '.gy',
    continente: 'SA'
  },
  GUF: {
    pais_id: 'GUF',
    pais: 'Guiana Francesa',
    pais_ingles: 'French Guiana',
    ddi: 594,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'GF',
    sigla_idioma: 'FR',
    sigla_fifa: 'GUF',
    tld: '.gf',
    continente: 'SA'
  },
  GIN: {
    pais_id: 'GIN',
    pais: 'Guinea',
    pais_ingles: 'Guinea',
    ddi: 224,
    moeda: 'GNF',
    moeda_nome: 'Guinea Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'GN',
    sigla_idioma: 'ES',
    sigla_fifa: 'GUI',
    tld: '.gn',
    continente: 'AF'
  },
  GNB: {
    pais_id: 'GNB',
    pais: 'Guinea-Bissau',
    pais_ingles: 'Guinea-Bissau',
    ddi: 245,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'GW',
    sigla_idioma: null,
    sigla_fifa: 'GNB',
    tld: '.gw',
    continente: 'AF'
  },
  HTI: {
    pais_id: 'HTI',
    pais: 'Haiti',
    pais_ingles: 'Haiti',
    ddi: 509,
    moeda: 'HTG',
    moeda_nome: 'US Dollar',
    moeda_simbolo: 'G',
    sigla_iso: 'HT',
    sigla_idioma: 'FR',
    sigla_fifa: 'HAI',
    tld: '.ht',
    continente: 'NA'
  },
  HMD: {
    pais_id: 'HMD',
    pais: 'Heard and Mcdonald Islands',
    pais_ingles: 'Heard and Mc Donald Islands',
    ddi: 672,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'HM',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.hm',
    continente: 'AN'
  },
  NLD: {
    pais_id: 'NLD',
    pais: 'Holanda',
    pais_ingles: 'Netherlands',
    ddi: 31,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'NL',
    sigla_idioma: 'NL',
    sigla_fifa: 'NED',
    tld: '.nl',
    continente: 'EU'
  },
  HND: {
    pais_id: 'HND',
    pais: 'Honduras',
    pais_ingles: 'Honduras',
    ddi: 504,
    moeda: 'HNL',
    moeda_nome: 'Lempira',
    moeda_simbolo: 'L',
    sigla_iso: 'HN',
    sigla_idioma: 'ES',
    sigla_fifa: 'HON',
    tld: '.hn',
    continente: 'NA'
  },
  HKG: {
    pais_id: 'HKG',
    pais: 'Hong Kong',
    pais_ingles: 'Hong Kong',
    ddi: 852,
    moeda: null,
    moeda_nome: 'Hong Kong Dollar',
    moeda_simbolo: 'HK$',
    sigla_iso: 'HK',
    sigla_idioma: 'EN',
    sigla_fifa: 'HKG',
    tld: '.hk',
    continente: 'AS'
  },
  HUN: {
    pais_id: 'HUN',
    pais: 'Hungria',
    pais_ingles: 'Hungary',
    ddi: 36,
    moeda: 'HUF',
    moeda_nome: 'Forint',
    moeda_simbolo: 'Ft',
    sigla_iso: 'HU',
    sigla_idioma: 'HU',
    sigla_fifa: 'HUN',
    tld: '.hu',
    continente: 'EU'
  },
  CXR: {
    pais_id: 'CXR',
    pais: 'Ilha Christmas',
    pais_ingles: 'Christmas Island',
    ddi: 61,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'CX',
    sigla_idioma: null,
    sigla_fifa: 'CXR',
    tld: '.cx',
    continente: 'AS'
  },
  IMN: {
    pais_id: 'IMN',
    pais: 'Ilha de Man',
    pais_ingles: 'Isle of Man',
    ddi: 44,
    moeda: 'GBP',
    moeda_nome: 'Pound Sterling',
    moeda_simbolo: '₤',
    sigla_iso: 'IM',
    sigla_idioma: null,
    sigla_fifa: 'GBM',
    tld: '.im',
    continente: 'EU'
  },
  KNA: {
    pais_id: 'KNA',
    pais: 'Ilha de São Cristóvão',
    pais_ingles: 'Saint Kitts',
    ddi: 1869,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'KN',
    sigla_idioma: null,
    sigla_fifa: 'SKN',
    tld: '.kn',
    continente: 'NA'
  },
  NFK: {
    pais_id: 'NFK',
    pais: 'Ilha Norfolk',
    pais_ingles: 'Norfolk Island',
    ddi: 672,
    moeda: null,
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'NF',
    sigla_idioma: null,
    sigla_fifa: 'NFK',
    tld: '.nf',
    continente: 'OC'
  },
  CYM: {
    pais_id: 'CYM',
    pais: 'Ilhas Cayman',
    pais_ingles: 'Cayman Islands',
    ddi: 1345,
    moeda: 'KYD',
    moeda_nome: 'Cayman Islands Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'KY',
    sigla_idioma: null,
    sigla_fifa: 'CAY',
    tld: '.ky',
    continente: 'NA'
  },
  CCK: {
    pais_id: 'CCK',
    pais: 'Ilhas Cocos (Keeling)',
    pais_ingles: 'Cocos (Keeling) Islands',
    ddi: 61891,
    moeda: 'AUD',
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'CC',
    sigla_idioma: null,
    sigla_fifa: 'CCK',
    tld: '.cc',
    continente: 'AS'
  },
  COK: {
    pais_id: 'COK',
    pais: 'Ilhas Cook',
    pais_ingles: 'Cook Islands',
    ddi: 682,
    moeda: 'NZD',
    moeda_nome: 'New Zealand Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'CK',
    sigla_idioma: null,
    sigla_fifa: 'COK',
    tld: '.ck',
    continente: 'OC'
  },
  SGS: {
    pais_id: 'SGS',
    pais: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    pais_ingles: 'South Georgia and the South Sandwich Islands',
    ddi: 500,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'GS',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.gs',
    continente: 'AN'
  },
  MUS: {
    pais_id: 'MUS',
    pais: 'Ilhas Maurício',
    pais_ingles: 'Mauritius',
    ddi: 230,
    moeda: 'MUR',
    moeda_nome: 'Mauritius Rupee',
    moeda_simbolo: 'Rs',
    sigla_iso: 'MU',
    sigla_idioma: 'EN',
    sigla_fifa: 'MRI',
    tld: '.mu',
    continente: 'AF'
  },
  UMI: {
    pais_id: 'UMI',
    pais: 'Ilhas Menores Distantes dos Estados Unidos',
    pais_ingles: 'United States Minor Outlying Islands',
    ddi: 246,
    moeda: null,
    moeda_nome: null,
    moeda_simbolo: null,
    sigla_iso: 'UM',
    sigla_idioma: 'ES',
    sigla_fifa: null,
    tld: '.um',
    continente: 'OC'
  },
  PCN: {
    pais_id: 'PCN',
    pais: 'Ilhas Pitcairn',
    pais_ingles: 'Pitcairn',
    ddi: 64,
    moeda: null,
    moeda_nome: 'New Zealand Dollar',
    moeda_simbolo: null,
    sigla_iso: 'PN',
    sigla_idioma: null,
    sigla_fifa: 'PCN',
    tld: '.pn',
    continente: 'OC'
  },
  VIR: {
    pais_id: 'VIR',
    pais: 'Ilhas Virgens Americanas',
    pais_ingles: 'Virgin Islands (US)',
    ddi: null,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'VI',
    sigla_idioma: null,
    sigla_fifa: 'VIR',
    tld: '.vi',
    continente: 'NA'
  },
  VGB: {
    pais_id: 'VGB',
    pais: 'Ilhas Virgens Britanicas',
    pais_ingles: 'Virgin Islands (British)',
    ddi: null,
    moeda: null,
    moeda_nome: 'Pound Sterling',
    moeda_simbolo: '₤',
    sigla_iso: 'VG',
    sigla_idioma: null,
    sigla_fifa: 'VGB',
    tld: '.vg',
    continente: 'NA'
  },
  IND: {
    pais_id: 'IND',
    pais: 'India',
    pais_ingles: 'India',
    ddi: 91,
    moeda: 'INR',
    moeda_nome: 'Indian Rupee',
    moeda_simbolo: '₹',
    sigla_iso: 'IN',
    sigla_idioma: 'HI',
    sigla_fifa: 'IND',
    tld: '.in',
    continente: 'AS'
  },
  IDN: {
    pais_id: 'IDN',
    pais: 'Indonésia',
    pais_ingles: 'Indonesia',
    ddi: 62,
    moeda: 'IDR',
    moeda_nome: 'Rupiah',
    moeda_simbolo: 'Rp',
    sigla_iso: 'ID',
    sigla_idioma: 'IN',
    sigla_fifa: 'IDN',
    tld: '.id',
    continente: 'AS'
  },
  IRN: {
    pais_id: 'IRN',
    pais: 'Iran (Islamic Republic of)',
    pais_ingles: 'Iran (Islamic Republic of)',
    ddi: 98,
    moeda: 'IRR',
    moeda_nome: 'Iranian Rial',
    moeda_simbolo: '﷼',
    sigla_iso: 'IR',
    sigla_idioma: 'FA',
    sigla_fifa: 'IRN',
    tld: '.ir',
    continente: 'AS'
  },
  IRQ: {
    pais_id: 'IRQ',
    pais: 'Iraque',
    pais_ingles: 'Iraq',
    ddi: 964,
    moeda: 'IQD',
    moeda_nome: 'Iraqi Dinar',
    moeda_simbolo: 'Ø¹.Ø¯',
    sigla_iso: 'IQ',
    sigla_idioma: 'AR',
    sigla_fifa: 'IRQ',
    tld: '.iq',
    continente: 'AS'
  },
  IRL: {
    pais_id: 'IRL',
    pais: 'Irlanda',
    pais_ingles: 'Ireland',
    ddi: 353,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'IE',
    sigla_idioma: 'EN',
    sigla_fifa: 'IRL',
    tld: '.ie',
    continente: 'EU'
  },
  ISL: {
    pais_id: 'ISL',
    pais: 'Islândia',
    pais_ingles: 'Iceland',
    ddi: 354,
    moeda: 'ISK',
    moeda_nome: 'Coroa - Islândia',
    moeda_simbolo: 'kr',
    sigla_iso: 'IS',
    sigla_idioma: 'IS',
    sigla_fifa: 'ISL',
    tld: '.is',
    continente: 'EU'
  },
  ISR: {
    pais_id: 'ISR',
    pais: 'Israel',
    pais_ingles: 'Israel',
    ddi: 972,
    moeda: 'ILS',
    moeda_nome: 'New Israeli Sheqel',
    moeda_simbolo: '₪',
    sigla_iso: 'IL',
    sigla_idioma: 'IW',
    sigla_fifa: 'ISR',
    tld: '.il',
    continente: 'AS'
  },
  ITA: {
    pais_id: 'ITA',
    pais: 'Italia',
    pais_ingles: 'Italy',
    ddi: 39,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'IT',
    sigla_idioma: null,
    sigla_fifa: 'ITA',
    tld: '.it',
    continente: 'EU'
  },
  JAM: {
    pais_id: 'JAM',
    pais: 'Jamaica',
    pais_ingles: 'Jamaica',
    ddi: 876,
    moeda: 'JMD',
    moeda_nome: 'Jamaican Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'JM',
    sigla_idioma: null,
    sigla_fifa: 'JAM',
    tld: '.jm',
    continente: 'NA'
  },
  JPN: {
    pais_id: 'JPN',
    pais: 'Japão',
    pais_ingles: 'Japan',
    ddi: 81,
    moeda: 'JPY',
    moeda_nome: 'Yen',
    moeda_simbolo: '¥',
    sigla_iso: 'JP',
    sigla_idioma: 'JA',
    sigla_fifa: 'JPN',
    tld: '.jp',
    continente: 'AS'
  },
  JEY: {
    pais_id: 'JEY',
    pais: 'Jersey',
    pais_ingles: 'Jersey',
    ddi: 44,
    moeda: 'GBP',
    moeda_nome: 'Pound Sterling',
    moeda_simbolo: '₤',
    sigla_iso: 'JE',
    sigla_idioma: null,
    sigla_fifa: 'GBJ',
    tld: '.je',
    continente: 'EU'
  },
  JOR: {
    pais_id: 'JOR',
    pais: 'Jordânia',
    pais_ingles: 'Jordan',
    ddi: 962,
    moeda: 'JOD',
    moeda_nome: 'Jordanian Dinar',
    moeda_simbolo: 'Ø¯.Ø§',
    sigla_iso: 'JO',
    sigla_idioma: 'AR',
    sigla_fifa: 'JOR',
    tld: '.jo',
    continente: 'AS'
  },
  KWT: {
    pais_id: 'KWT',
    pais: 'Kuwait',
    pais_ingles: 'Kuwait',
    ddi: 965,
    moeda: 'KWD',
    moeda_nome: 'Kuwaiti Dinar',
    moeda_simbolo: 'KD',
    sigla_iso: 'KW',
    sigla_idioma: 'AR',
    sigla_fifa: 'KUW',
    tld: '.kw',
    continente: 'AS'
  },
  LAO: {
    pais_id: 'LAO',
    pais: 'Laos',
    pais_ingles: 'Laos',
    ddi: 856,
    moeda: 'LAK',
    moeda_nome: 'Kip',
    moeda_simbolo: 'â‚­',
    sigla_iso: 'LA',
    sigla_idioma: 'LO',
    sigla_fifa: 'LAO',
    tld: '.la',
    continente: 'AS'
  },
  LSO: {
    pais_id: 'LSO',
    pais: 'Lesoto',
    pais_ingles: 'Lesotho',
    ddi: 266,
    moeda: 'LSL',
    moeda_nome: 'Rand',
    moeda_simbolo: 'L',
    sigla_iso: 'LS',
    sigla_idioma: 'EN',
    sigla_fifa: 'LES',
    tld: '.ls',
    continente: 'AF'
  },
  LVA: {
    pais_id: 'LVA',
    pais: 'Letônia',
    pais_ingles: 'Latvia',
    ddi: 371,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'LV',
    sigla_idioma: 'RU',
    sigla_fifa: 'LVA',
    tld: '.lv',
    continente: 'EU'
  },
  LBN: {
    pais_id: 'LBN',
    pais: 'Libano',
    pais_ingles: 'Lebanon',
    ddi: 961,
    moeda: 'LBP',
    moeda_nome: 'Lebanese Pound',
    moeda_simbolo: 'ل',
    sigla_iso: 'LB',
    sigla_idioma: 'AR',
    sigla_fifa: 'LIB',
    tld: '.lb',
    continente: 'AS'
  },
  LBR: {
    pais_id: 'LBR',
    pais: 'Liberia',
    pais_ingles: 'Liberia',
    ddi: 231,
    moeda: 'LRD',
    moeda_nome: 'Liberian Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'LR',
    sigla_idioma: 'EN',
    sigla_fifa: 'LBR',
    tld: '.lr',
    continente: 'AF'
  },
  LBY: {
    pais_id: 'LBY',
    pais: 'Líbia',
    pais_ingles: 'Libyan Arab Jamahiriya',
    ddi: 218,
    moeda: 'LYD',
    moeda_nome: 'Libyan Dinar',
    moeda_simbolo: 'Ù„.Ø¯',
    sigla_iso: 'LY',
    sigla_idioma: 'AR',
    sigla_fifa: 'LBY',
    tld: '.ly',
    continente: 'AF'
  },
  LIE: {
    pais_id: 'LIE',
    pais: 'Liechtenstein',
    pais_ingles: 'Liechtenstein',
    ddi: 423,
    moeda: 'CHF',
    moeda_nome: 'Swiss Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'LI',
    sigla_idioma: 'DE',
    sigla_fifa: 'LIE',
    tld: '.li',
    continente: 'EU'
  },
  LTU: {
    pais_id: 'LTU',
    pais: 'Lituânia',
    pais_ingles: 'Lithuania',
    ddi: 370,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'LT',
    sigla_idioma: 'RU',
    sigla_fifa: 'LTU',
    tld: '.lt',
    continente: 'EU'
  },
  LUX: {
    pais_id: 'LUX',
    pais: 'Luxemburgo',
    pais_ingles: 'Luxembourg',
    ddi: 352,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'LU',
    sigla_idioma: 'FR',
    sigla_fifa: 'LUX',
    tld: '.lu',
    continente: 'EU'
  },
  MAC: {
    pais_id: 'MAC',
    pais: 'Macau',
    pais_ingles: 'Macau',
    ddi: 853,
    moeda: null,
    moeda_nome: 'Pataca',
    moeda_simbolo: null,
    sigla_iso: 'MO',
    sigla_idioma: 'PT',
    sigla_fifa: 'MAC',
    tld: '.mo',
    continente: 'AS'
  },
  MKD: {
    pais_id: 'MKD',
    pais: 'Macedônia',
    pais_ingles: 'Macedonia',
    ddi: 389,
    moeda: null,
    moeda_nome: 'Denar',
    moeda_simbolo: null,
    sigla_iso: 'MK',
    sigla_idioma: 'MK',
    sigla_fifa: 'MKD',
    tld: '.mk',
    continente: 'EU'
  },
  MDG: {
    pais_id: 'MDG',
    pais: 'Madagascar',
    pais_ingles: 'Madagascar',
    ddi: 261,
    moeda: 'MGA',
    moeda_nome: 'Malagasy Ariary',
    moeda_simbolo: 'Ar',
    sigla_iso: 'MG',
    sigla_idioma: 'FR',
    sigla_fifa: 'MAD',
    tld: '.mg',
    continente: 'AF'
  },
  MYS: {
    pais_id: 'MYS',
    pais: 'Malásia',
    pais_ingles: 'Malaysia',
    ddi: 60,
    moeda: 'MYR',
    moeda_nome: 'Malaysian Ringgit',
    moeda_simbolo: 'RM',
    sigla_iso: 'MY',
    sigla_idioma: 'MS',
    sigla_fifa: 'MAS',
    tld: '.my',
    continente: 'AS'
  },
  MWI: {
    pais_id: 'MWI',
    pais: 'Malawi',
    pais_ingles: 'Malawi',
    ddi: 265,
    moeda: 'MWK',
    moeda_nome: 'Kwacha',
    moeda_simbolo: 'MK',
    sigla_iso: 'MW',
    sigla_idioma: 'EN',
    sigla_fifa: 'MWI',
    tld: '.mw',
    continente: 'AF'
  },
  MDV: {
    pais_id: 'MDV',
    pais: 'Maldivas',
    pais_ingles: 'Maldives',
    ddi: 960,
    moeda: 'MVR',
    moeda_nome: 'Rufiyaa',
    moeda_simbolo: 'Rf',
    sigla_iso: 'MV',
    sigla_idioma: 'EN',
    sigla_fifa: 'MDV',
    tld: '.mv',
    continente: 'AS'
  },
  MLI: {
    pais_id: 'MLI',
    pais: 'Mali',
    pais_ingles: 'Mali',
    ddi: 223,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'ML',
    sigla_idioma: 'FR',
    sigla_fifa: 'MLI',
    tld: '.ml',
    continente: 'AF'
  },
  MLT: {
    pais_id: 'MLT',
    pais: 'Malta',
    pais_ingles: 'Malta',
    ddi: 356,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'MT',
    sigla_idioma: 'MT',
    sigla_fifa: 'MLT',
    tld: '.mt',
    continente: 'EU'
  },
  MAR: {
    pais_id: 'MAR',
    pais: 'Marrocos',
    pais_ingles: 'Morocco',
    ddi: 212,
    moeda: 'MAD',
    moeda_nome: 'Moroccan Dirham',
    moeda_simbolo: 'DH',
    sigla_iso: 'MA',
    sigla_idioma: null,
    sigla_fifa: 'MAR',
    tld: '.ma',
    continente: 'AF'
  },
  MHL: {
    pais_id: 'MHL',
    pais: 'Marshall Islands',
    pais_ingles: 'Marshall Islands',
    ddi: 692,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'MH',
    sigla_idioma: null,
    sigla_fifa: 'MHL',
    tld: '.mh',
    continente: 'OC'
  },
  MTQ: {
    pais_id: 'MTQ',
    pais: 'Martinica',
    pais_ingles: 'Martinique',
    ddi: 596,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'MQ',
    sigla_idioma: 'FR',
    sigla_fifa: 'MTQ',
    tld: '.mq',
    continente: 'NA'
  },
  MRT: {
    pais_id: 'MRT',
    pais: 'Mauritânia',
    pais_ingles: 'Mauritania',
    ddi: 222,
    moeda: 'MRO',
    moeda_nome: 'Ouguiya',
    moeda_simbolo: 'UM',
    sigla_iso: 'MR',
    sigla_idioma: 'AR',
    sigla_fifa: 'MTN',
    tld: '.mr',
    continente: 'AF'
  },
  MYT: {
    pais_id: 'MYT',
    pais: 'Mayotte',
    pais_ingles: 'Mayotte',
    ddi: 262,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'YT',
    sigla_idioma: 'EN',
    sigla_fifa: 'MYT',
    tld: '.yt',
    continente: 'AF'
  },
  MEX: {
    pais_id: 'MEX',
    pais: 'México',
    pais_ingles: 'Mexico',
    ddi: 52,
    moeda: 'MXN',
    moeda_nome: 'Mexican Peso',
    moeda_simbolo: '$',
    sigla_iso: 'MX',
    sigla_idioma: 'ES',
    sigla_fifa: 'MEX',
    tld: '.mx',
    continente: 'NA'
  },
  FSM: {
    pais_id: 'FSM',
    pais: 'Micronesia Federated States of',
    pais_ingles: 'Micronesia Federated States of',
    ddi: 691,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'FM',
    sigla_idioma: 'EN',
    sigla_fifa: 'FSM',
    tld: '.fm',
    continente: 'OC'
  },
  MOZ: {
    pais_id: 'MOZ',
    pais: 'Moçambique',
    pais_ingles: 'Mozambique',
    ddi: 258,
    moeda: 'MZN',
    moeda_nome: 'Mozambique Metical',
    moeda_simbolo: 'MT',
    sigla_iso: 'MZ',
    sigla_idioma: 'PT',
    sigla_fifa: 'MOZ',
    tld: '.mz',
    continente: 'AF'
  },
  MDA: {
    pais_id: 'MDA',
    pais: 'Moldávia',
    pais_ingles: 'Moldova Republic of',
    ddi: 373,
    moeda: 'MDL',
    moeda_nome: 'Moldovan Leu',
    moeda_simbolo: 'L',
    sigla_iso: 'MD',
    sigla_idioma: 'RU',
    sigla_fifa: 'MDA',
    tld: '.md',
    continente: 'EU'
  },
  MCO: {
    pais_id: 'MCO',
    pais: 'Mônaco',
    pais_ingles: 'Monaco',
    ddi: 377,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'MC',
    sigla_idioma: null,
    sigla_fifa: 'MON',
    tld: '.mc',
    continente: 'EU'
  },
  MNG: {
    pais_id: 'MNG',
    pais: 'Mongólia',
    pais_ingles: 'Mongolia',
    ddi: 976,
    moeda: 'MNT',
    moeda_nome: 'Tugrik',
    moeda_simbolo: '₮',
    sigla_iso: 'MN',
    sigla_idioma: 'MN',
    sigla_fifa: 'MNG',
    tld: '.mn',
    continente: 'AS'
  },
  MNE: {
    pais_id: 'MNE',
    pais: 'Montenegro',
    pais_ingles: 'Montenegro',
    ddi: 382,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: 'T',
    sigla_iso: 'ME',
    sigla_idioma: null,
    sigla_fifa: 'MNE',
    tld: '.me',
    continente: 'EU'
  },
  MSR: {
    pais_id: 'MSR',
    pais: 'Montserrat',
    pais_ingles: 'Montserrat',
    ddi: 1664,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'MS',
    sigla_idioma: null,
    sigla_fifa: 'MSR',
    tld: '.ms',
    continente: 'NA'
  },
  MMR: {
    pais_id: 'MMR',
    pais: 'Myanmar',
    pais_ingles: 'Myanmar',
    ddi: 95,
    moeda: 'MMK',
    moeda_nome: 'Kyat',
    moeda_simbolo: 'Ks',
    sigla_iso: 'MM',
    sigla_idioma: null,
    sigla_fifa: 'MYA',
    tld: '.mm',
    continente: 'AS'
  },
  NAM: {
    pais_id: 'NAM',
    pais: 'Namíbia',
    pais_ingles: 'Namibia',
    ddi: 264,
    moeda: 'NAD',
    moeda_nome: 'Rand',
    moeda_simbolo: '$',
    sigla_iso: 'NA',
    sigla_idioma: 'EN',
    sigla_fifa: 'NAM',
    tld: '.na',
    continente: 'AF'
  },
  NRU: {
    pais_id: 'NRU',
    pais: 'Nauru',
    pais_ingles: 'Nauru',
    ddi: 674,
    moeda: 'AUD',
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'NR',
    sigla_idioma: 'EN',
    sigla_fifa: 'NRU',
    tld: '.nr',
    continente: 'OC'
  },
  NPL: {
    pais_id: 'NPL',
    pais: 'Nepal',
    pais_ingles: 'Nepal',
    ddi: 977,
    moeda: 'NPR',
    moeda_nome: 'Nepalese Rupee',
    moeda_simbolo: 'रू',
    sigla_iso: 'NP',
    sigla_idioma: 'NE',
    sigla_fifa: 'NEP',
    tld: '.np',
    continente: 'AS'
  },
  NIC: {
    pais_id: 'NIC',
    pais: 'Nicarágua',
    pais_ingles: 'Nicaragua',
    ddi: 505,
    moeda: 'NIO',
    moeda_nome: 'Cordoba Oro',
    moeda_simbolo: 'C$',
    sigla_iso: 'NI',
    sigla_idioma: 'ES',
    sigla_fifa: 'NCA',
    tld: '.ni',
    continente: 'NA'
  },
  NER: {
    pais_id: 'NER',
    pais: 'Níger',
    pais_ingles: 'Niger',
    ddi: 227,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'NE',
    sigla_idioma: 'FR',
    sigla_fifa: 'NIG',
    tld: '.ne',
    continente: 'AF'
  },
  NGA: {
    pais_id: 'NGA',
    pais: 'Nigéria',
    pais_ingles: 'Nigeria',
    ddi: 234,
    moeda: 'NGN',
    moeda_nome: 'Naira',
    moeda_simbolo: 'â‚¦',
    sigla_iso: 'NG',
    sigla_idioma: 'EN',
    sigla_fifa: 'NGA',
    tld: '.ng',
    continente: 'AF'
  },
  NIU: {
    pais_id: 'NIU',
    pais: 'Niue',
    pais_ingles: 'Niue',
    ddi: 683,
    moeda: 'NZD',
    moeda_nome: 'New Zealand Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'NU',
    sigla_idioma: 'EN',
    sigla_fifa: 'NIU',
    tld: '.nu',
    continente: 'OC'
  },
  MNP: {
    pais_id: 'MNP',
    pais: 'Northern Mariana Islands',
    pais_ingles: 'Northern Mariana Islands',
    ddi: null,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'MP',
    sigla_idioma: null,
    sigla_fifa: 'NMI',
    tld: '.mp',
    continente: 'OC'
  },
  NOR: {
    pais_id: 'NOR',
    pais: 'Noruega',
    pais_ingles: 'Norway',
    ddi: 47,
    moeda: 'NOK',
    moeda_nome: 'Norwegian Krone',
    moeda_simbolo: 'kr',
    sigla_iso: 'NO',
    sigla_idioma: null,
    sigla_fifa: 'NOR',
    tld: '.no',
    continente: 'EU'
  },
  NCL: {
    pais_id: 'NCL',
    pais: 'Nova Caledônia',
    pais_ingles: 'New Caledonia',
    ddi: 687,
    moeda: 'XPF',
    moeda_nome: 'CFP Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'NC',
    sigla_idioma: 'FR',
    sigla_fifa: 'NCL',
    tld: '.nc',
    continente: 'OC'
  },
  NZL: {
    pais_id: 'NZL',
    pais: 'Nova Zelândia',
    pais_ingles: 'New Zealand',
    ddi: 64,
    moeda: 'NZD',
    moeda_nome: 'New Zealand Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'NZ',
    sigla_idioma: 'EN',
    sigla_fifa: 'NZL',
    tld: '.nz',
    continente: 'OC'
  },
  OMN: {
    pais_id: 'OMN',
    pais: 'Oman',
    pais_ingles: 'Oman',
    ddi: 968,
    moeda: 'OMR',
    moeda_nome: 'Rial Omani',
    moeda_simbolo: 'Ø±.Ø¹.',
    sigla_iso: 'OM',
    sigla_idioma: 'AR',
    sigla_fifa: 'OMA',
    tld: '.om',
    continente: 'AS'
  },
  PLW: {
    pais_id: 'PLW',
    pais: 'Palau',
    pais_ingles: 'Palau',
    ddi: 680,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'PW',
    sigla_idioma: 'EN',
    sigla_fifa: 'PLW',
    tld: '.pw',
    continente: 'OC'
  },
  PSE: {
    pais_id: 'PSE',
    pais: 'Palestinian Territory',
    pais_ingles: 'Palestinian Territory',
    ddi: 970,
    moeda: null,
    moeda_nome: 'No universal currency',
    moeda_simbolo: null,
    sigla_iso: 'PS',
    sigla_idioma: null,
    sigla_fifa: 'PLE',
    tld: '.ps',
    continente: 'AS'
  },
  PAN: {
    pais_id: 'PAN',
    pais: 'Panamá',
    pais_ingles: 'Panama',
    ddi: 507,
    moeda: 'PAB',
    moeda_nome: 'US Dollar',
    moeda_simbolo: 'B/.',
    sigla_iso: 'PA',
    sigla_idioma: 'ES',
    sigla_fifa: 'PAN',
    tld: '.pa',
    continente: 'NA'
  },
  PNG: {
    pais_id: 'PNG',
    pais: 'Papua Nova Guine',
    pais_ingles: 'Papua New Guinea',
    ddi: 675,
    moeda: 'PGK',
    moeda_nome: 'Kina',
    moeda_simbolo: 'K',
    sigla_iso: 'PG',
    sigla_idioma: 'EN',
    sigla_fifa: 'PNG',
    tld: '.pg',
    continente: 'OC'
  },
  PAK: {
    pais_id: 'PAK',
    pais: 'Paquistão',
    pais_ingles: 'Pakistan',
    ddi: 92,
    moeda: 'PKR',
    moeda_nome: 'Pakistan Rupee',
    moeda_simbolo: 'रू',
    sigla_iso: 'PK',
    sigla_idioma: 'UR',
    sigla_fifa: 'PAK',
    tld: '.pk',
    continente: 'AS'
  },
  PRY: {
    pais_id: 'PRY',
    pais: 'Paraguai',
    pais_ingles: 'Paraguay',
    ddi: 595,
    moeda: 'PYG',
    moeda_nome: 'Guarani',
    moeda_simbolo: '₲',
    sigla_iso: 'PY',
    sigla_idioma: 'ES',
    sigla_fifa: 'PAR',
    tld: '.py',
    continente: 'SA'
  },
  PER: {
    pais_id: 'PER',
    pais: 'Peru',
    pais_ingles: 'Peru',
    ddi: 51,
    moeda: 'PEN',
    moeda_nome: 'Nuevo Sol',
    moeda_simbolo: 'S/.',
    sigla_iso: 'PE',
    sigla_idioma: 'ES',
    sigla_fifa: 'PER',
    tld: '.pe',
    continente: 'SA'
  },
  PYF: {
    pais_id: 'PYF',
    pais: 'Polinésia Francesa',
    pais_ingles: 'French Polynesia',
    ddi: 689,
    moeda: 'XPF',
    moeda_nome: 'CFP Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'PF',
    sigla_idioma: null,
    sigla_fifa: 'TAH',
    tld: '.pf',
    continente: 'OC'
  },
  POL: {
    pais_id: 'POL',
    pais: 'Polônia',
    pais_ingles: 'Poland',
    ddi: 48,
    moeda: 'PLN',
    moeda_nome: 'Zloty',
    moeda_simbolo: 'zÅ‚',
    sigla_iso: 'PL',
    sigla_idioma: 'PL',
    sigla_fifa: 'POL',
    tld: '.pl',
    continente: 'EU'
  },
  PRI: {
    pais_id: 'PRI',
    pais: 'Porto Rico',
    pais_ingles: 'Puerto Rico',
    ddi: 1,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'PR',
    sigla_idioma: null,
    sigla_fifa: 'PUR',
    tld: '.pr',
    continente: 'NA'
  },
  PRT: {
    pais_id: 'PRT',
    pais: 'Portugal',
    pais_ingles: 'Portugal',
    ddi: 351,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'PT',
    sigla_idioma: 'PT',
    sigla_fifa: 'POR',
    tld: '.pt',
    continente: 'EU'
  },
  QAT: {
    pais_id: 'QAT',
    pais: 'Qatar',
    pais_ingles: 'Qatar',
    ddi: 974,
    moeda: 'QAR',
    moeda_nome: 'Qatari Rial',
    moeda_simbolo: 'QR',
    sigla_iso: 'QA',
    sigla_idioma: 'AR',
    sigla_fifa: 'QAT',
    tld: '.qa',
    continente: 'AS'
  },
  KEN: {
    pais_id: 'KEN',
    pais: 'Quênia',
    pais_ingles: 'Kenya',
    ddi: 254,
    moeda: 'KES',
    moeda_nome: 'Kenyan Shilling',
    moeda_simbolo: 'Sh',
    sigla_iso: 'KE',
    sigla_idioma: 'SW',
    sigla_fifa: 'KEN',
    tld: '.ke',
    continente: 'AF'
  },
  KGZ: {
    pais_id: 'KGZ',
    pais: 'Quirguistão',
    pais_ingles: 'Kyrgyzstan',
    ddi: 996,
    moeda: 'KGS',
    moeda_nome: 'Som',
    moeda_simbolo: 'лв',
    sigla_iso: 'KG',
    sigla_idioma: null,
    sigla_fifa: 'KGZ',
    tld: '.kg',
    continente: 'AS'
  },
  KIR: {
    pais_id: 'KIR',
    pais: 'Quiribati',
    pais_ingles: 'Kiribati',
    ddi: 686,
    moeda: 'AUD',
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'KI',
    sigla_idioma: 'EN',
    sigla_fifa: 'KIR',
    tld: '.ki',
    continente: 'OC'
  },
  GBR: {
    pais_id: 'GBR',
    pais: 'Reino Unido',
    pais_ingles: 'United Kingdom',
    ddi: 44,
    moeda: 'GBP',
    moeda_nome: 'Pound Sterling',
    moeda_simbolo: '₤',
    sigla_iso: 'GB',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.uk',
    continente: 'EU'
  },
  DOM: {
    pais_id: 'DOM',
    pais: 'República Dominicana',
    pais_ingles: 'Dominican Republic',
    ddi: 809,
    moeda: 'DOP',
    moeda_nome: 'Dominican Peso',
    moeda_simbolo: '$',
    sigla_iso: 'DO',
    sigla_idioma: null,
    sigla_fifa: 'DOM',
    tld: '.do',
    continente: 'NA'
  },
  CZE: {
    pais_id: 'CZE',
    pais: 'República Tcheca',
    pais_ingles: 'Czech Republic',
    ddi: 420,
    moeda: 'CZK',
    moeda_nome: 'Czech koruna',
    moeda_simbolo: 'KÄ',
    sigla_iso: 'CZ',
    sigla_idioma: null,
    sigla_fifa: 'CZE',
    tld: '.cz',
    continente: 'EU'
  },
  REU: {
    pais_id: 'REU',
    pais: 'Reunion',
    pais_ingles: 'Reunion',
    ddi: 262,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'RE',
    sigla_idioma: null,
    sigla_fifa: 'REU',
    tld: '.re',
    continente: 'AF'
  },
  ROU: {
    pais_id: 'ROU',
    pais: 'Romênia',
    pais_ingles: 'Romania',
    ddi: 40,
    moeda: 'RON',
    moeda_nome: 'New Romanian Leu',
    moeda_simbolo: 'lei',
    sigla_iso: 'RO',
    sigla_idioma: 'RO',
    sigla_fifa: 'ROU',
    tld: '.ro',
    continente: 'EU'
  },
  RUS: {
    pais_id: 'RUS',
    pais: 'Russian Federation',
    pais_ingles: 'Russian Federation',
    ddi: null,
    moeda: 'RUB',
    moeda_nome: 'Russian Ruble',
    moeda_simbolo: '₽',
    sigla_iso: 'RU',
    sigla_idioma: null,
    sigla_fifa: 'RUS',
    tld: '.ru',
    continente: 'EU'
  },
  RWA: {
    pais_id: 'RWA',
    pais: 'Rwanda',
    pais_ingles: 'Rwanda',
    ddi: 250,
    moeda: 'RWF',
    moeda_nome: 'Rwanda Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'RW',
    sigla_idioma: 'FR',
    sigla_fifa: 'RWA',
    tld: '.rw',
    continente: 'AF'
  },
  ESH: {
    pais_id: 'ESH',
    pais: 'Saara Ocidental',
    pais_ingles: 'Western Sahara',
    ddi: 212,
    moeda: null,
    moeda_nome: 'Moroccan Dirham',
    moeda_simbolo: null,
    sigla_iso: 'EH',
    sigla_idioma: 'AR',
    sigla_fifa: 'SAH',
    tld: '.eh',
    continente: 'AF'
  },
  BLM: {
    pais_id: 'BLM',
    pais: 'Saint Barthelemy',
    pais_ingles: 'Saint Barthelemy',
    ddi: null,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: 'T',
    sigla_iso: 'BL',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.gp',
    continente: 'NA'
  },
  SHN: {
    pais_id: 'SHN',
    pais: 'Saint Helena',
    pais_ingles: 'Saint Helena',
    ddi: 290,
    moeda: 'SHP',
    moeda_nome: 'Saint Helena Pound',
    moeda_simbolo: '₤',
    sigla_iso: 'SH',
    sigla_idioma: null,
    sigla_fifa: 'SHN',
    tld: '.sh',
    continente: 'AF'
  },
  MAF: {
    pais_id: 'MAF',
    pais: 'Saint Martin (French part)',
    pais_ingles: 'Saint Martin (French part)',
    ddi: null,
    moeda: 'ANG',
    moeda_nome: 'Euro',
    moeda_simbolo: 'Æ’',
    sigla_iso: 'MF',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.gp',
    continente: 'NA'
  },
  SPM: {
    pais_id: 'SPM',
    pais: 'Saint Pierre and Miquelon',
    pais_ingles: 'Saint Pierre and Miquelon',
    ddi: 508,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'PM',
    sigla_idioma: null,
    sigla_fifa: 'SPM',
    tld: '.pm',
    continente: 'NA'
  },
  VCT: {
    pais_id: 'VCT',
    pais: 'Saint Vincent Grenadines',
    pais_ingles: 'Saint Vincent Grenadines',
    ddi: null,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'VC',
    sigla_idioma: null,
    sigla_fifa: 'VIN',
    tld: '.vc',
    continente: 'NA'
  },
  WSM: {
    pais_id: 'WSM',
    pais: 'Samoa',
    pais_ingles: 'Samoa',
    ddi: 684,
    moeda: 'WST',
    moeda_nome: 'Tala',
    moeda_simbolo: 'T',
    sigla_iso: 'WS',
    sigla_idioma: 'EN',
    sigla_fifa: 'SAM',
    tld: '.ws',
    continente: 'OC'
  },
  ASM: {
    pais_id: 'ASM',
    pais: 'Samoa Americana',
    pais_ingles: 'American Samoa',
    ddi: 1684,
    moeda: null,
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'AS',
    sigla_idioma: null,
    sigla_fifa: 'ASA',
    tld: '.as',
    continente: 'OC'
  },
  SMR: {
    pais_id: 'SMR',
    pais: 'San Marino',
    pais_ingles: 'San Marino',
    ddi: 378,
    moeda: 'EUR',
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'SM',
    sigla_idioma: null,
    sigla_fifa: 'SMR',
    tld: '.sm',
    continente: 'EU'
  },
  LCA: {
    pais_id: 'LCA',
    pais: 'Santa Lúcia',
    pais_ingles: 'Saint Lucia',
    ddi: 1758,
    moeda: 'XCD',
    moeda_nome: 'Dolar Caribe Oriental',
    moeda_simbolo: '$',
    sigla_iso: 'LC',
    sigla_idioma: null,
    sigla_fifa: 'LCA',
    tld: '.lc',
    continente: 'NA'
  },
  STP: {
    pais_id: 'STP',
    pais: 'São Tomé e Príncipe',
    pais_ingles: 'Sao Tome and Principe',
    ddi: 239,
    moeda: 'STD',
    moeda_nome: 'Dobra',
    moeda_simbolo: 'Db',
    sigla_iso: 'ST',
    sigla_idioma: 'EN',
    sigla_fifa: 'STP',
    tld: '.st',
    continente: 'AF'
  },
  SEN: {
    pais_id: 'SEN',
    pais: 'Senegal',
    pais_ingles: 'Senegal',
    ddi: 221,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'SN',
    sigla_idioma: 'FR',
    sigla_fifa: 'SEN',
    tld: '.sn',
    continente: 'AF'
  },
  SRB: {
    pais_id: 'SRB',
    pais: 'Sérvia',
    pais_ingles: 'Serbia',
    ddi: 381,
    moeda: 'RSD',
    moeda_nome: 'Serbian Dinar',
    moeda_simbolo: 'РСД',
    sigla_iso: 'RS',
    sigla_idioma: null,
    sigla_fifa: 'SRB',
    tld: '.rs',
    continente: 'EU'
  },
  SYC: {
    pais_id: 'SYC',
    pais: 'Seychelles',
    pais_ingles: 'Seychelles',
    ddi: 248,
    moeda: 'SCR',
    moeda_nome: 'Seychelles Rupee',
    moeda_simbolo: 'SR',
    sigla_iso: 'SC',
    sigla_idioma: 'EN',
    sigla_fifa: 'SEY',
    tld: '.sc',
    continente: 'AF'
  },
  SLE: {
    pais_id: 'SLE',
    pais: 'Sierra Leone',
    pais_ingles: 'Sierra Leone',
    ddi: 232,
    moeda: 'SLL',
    moeda_nome: 'Leone',
    moeda_simbolo: 'Le',
    sigla_iso: 'SL',
    sigla_idioma: 'EN',
    sigla_fifa: 'SLE',
    tld: '.sl',
    continente: 'AF'
  },
  SGP: {
    pais_id: 'SGP',
    pais: 'Singapura',
    pais_ingles: 'Singapore',
    ddi: 65,
    moeda: 'BND',
    moeda_nome: 'Singapore Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'SG',
    sigla_idioma: 'EN',
    sigla_fifa: 'SIN',
    tld: '.sg',
    continente: 'AS'
  },
  SLB: {
    pais_id: 'SLB',
    pais: 'Solomon Islands',
    pais_ingles: 'Solomon Islands',
    ddi: 677,
    moeda: 'SBD',
    moeda_nome: 'Solomon Islands Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'SB',
    sigla_idioma: null,
    sigla_fifa: 'SOL',
    tld: '.sb',
    continente: 'OC'
  },
  SOM: {
    pais_id: 'SOM',
    pais: 'Somália',
    pais_ingles: 'Somalia',
    ddi: 252,
    moeda: 'SOS',
    moeda_nome: 'Somali Shilling',
    moeda_simbolo: 'Sh',
    sigla_iso: 'SO',
    sigla_idioma: 'AR',
    sigla_fifa: 'SOM',
    tld: '.so',
    continente: 'AF'
  },
  LKA: {
    pais_id: 'LKA',
    pais: 'Sri Lanka',
    pais_ingles: 'Sri Lanka',
    ddi: 94,
    moeda: 'LKR',
    moeda_nome: 'Sri Lanka Rupee',
    moeda_simbolo: 'Rs',
    sigla_iso: 'LK',
    sigla_idioma: null,
    sigla_fifa: 'SRI',
    tld: '.lk',
    continente: 'AS'
  },
  SWZ: {
    pais_id: 'SWZ',
    pais: 'Suazilândia',
    pais_ingles: 'Swaziland',
    ddi: 268,
    moeda: 'SZL',
    moeda_nome: 'Lilangeni',
    moeda_simbolo: 'L',
    sigla_iso: 'SZ',
    sigla_idioma: 'EN',
    sigla_fifa: 'SWZ',
    tld: '.sz',
    continente: 'AF'
  },
  SDN: {
    pais_id: 'SDN',
    pais: 'Sudan',
    pais_ingles: 'Sudan',
    ddi: 249,
    moeda: 'SDG',
    moeda_nome: 'Sudanese Pound',
    moeda_simbolo: 'SD',
    sigla_iso: 'SD',
    sigla_idioma: 'AR',
    sigla_fifa: 'SUD',
    tld: '.sd',
    continente: 'AF'
  },
  SWE: {
    pais_id: 'SWE',
    pais: 'Suécia',
    pais_ingles: 'Sweden',
    ddi: 46,
    moeda: 'SEK',
    moeda_nome: 'Swedish Krona',
    moeda_simbolo: 'kr',
    sigla_iso: 'SE',
    sigla_idioma: 'SV',
    sigla_fifa: 'SWE',
    tld: '.se',
    continente: 'EU'
  },
  CHE: {
    pais_id: 'CHE',
    pais: 'Suíça',
    pais_ingles: 'Switzerland',
    ddi: 41,
    moeda: 'CHF',
    moeda_nome: 'Swiss Franc',
    moeda_simbolo: 'Fr',
    sigla_iso: 'CH',
    sigla_idioma: 'FR',
    sigla_fifa: 'SUI',
    tld: '.ch',
    continente: 'EU'
  },
  SUR: {
    pais_id: 'SUR',
    pais: 'Suriname',
    pais_ingles: 'Suriname',
    ddi: 597,
    moeda: 'SRD',
    moeda_nome: 'Surinam Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'SR',
    sigla_idioma: 'NL',
    sigla_fifa: 'SUR',
    tld: '.sr',
    continente: 'SA'
  },
  SJM: {
    pais_id: 'SJM',
    pais: 'Svalbard and Jan Mayen Islands',
    pais_ingles: 'Svalbard and Jan Mayen Islands',
    ddi: 47,
    moeda: null,
    moeda_nome: 'Norwegian Krone',
    moeda_simbolo: null,
    sigla_iso: 'SJ',
    sigla_idioma: 'NO',
    sigla_fifa: null,
    tld: '.sj',
    continente: 'EU'
  },
  SYR: {
    pais_id: 'SYR',
    pais: 'Syrian Arab Republic',
    pais_ingles: 'Syrian Arab Republic',
    ddi: 963,
    moeda: 'SYP',
    moeda_nome: 'Syrian Pound',
    moeda_simbolo: '£S',
    sigla_iso: 'SY',
    sigla_idioma: 'AR',
    sigla_fifa: 'SYR',
    tld: '.sy',
    continente: 'AS'
  },
  THA: {
    pais_id: 'THA',
    pais: 'Tailândia',
    pais_ingles: 'Thailand',
    ddi: 66,
    moeda: 'THB',
    moeda_nome: 'Baht',
    moeda_simbolo: '฿',
    sigla_iso: 'TH',
    sigla_idioma: 'TH',
    sigla_fifa: 'THA',
    tld: '.th',
    continente: 'AS'
  },
  TWN: {
    pais_id: 'TWN',
    pais: 'Taiwan',
    pais_ingles: 'Taiwan',
    ddi: 886,
    moeda: 'TWD',
    moeda_nome: 'New Taiwan dollar',
    moeda_simbolo: '$',
    sigla_iso: 'TW',
    sigla_idioma: 'ZH',
    sigla_fifa: 'TPE',
    tld: '.tw',
    continente: 'AS'
  },
  TJK: {
    pais_id: 'TJK',
    pais: 'Tajiquistão',
    pais_ingles: 'Tajikistan',
    ddi: 992,
    moeda: 'TJS',
    moeda_nome: 'Somoni',
    moeda_simbolo: 'Ð…Ðœ',
    sigla_iso: 'TJ',
    sigla_idioma: null,
    sigla_fifa: 'TJK',
    tld: '.tj',
    continente: 'AS'
  },
  TZA: {
    pais_id: 'TZA',
    pais: 'Tanzânia',
    pais_ingles: 'Tanzania',
    ddi: 255,
    moeda: 'TZS',
    moeda_nome: 'Tanzanian Shilling',
    moeda_simbolo: 'Sh',
    sigla_iso: 'TZ',
    sigla_idioma: 'EN',
    sigla_fifa: 'TAN',
    tld: '.tz',
    continente: 'AF'
  },
  IOT: {
    pais_id: 'IOT',
    pais: 'Território do Oceano Índico Britânico',
    pais_ingles: 'British Indian Ocean Territory',
    ddi: 246,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'IO',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: '.io',
    continente: 'AS'
  },
  TLS: {
    pais_id: 'TLS',
    pais: 'Timor-Lest',
    pais_ingles: 'East Timor',
    ddi: 670,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'TP',
    sigla_idioma: null,
    sigla_fifa: null,
    tld: null,
    continente: null
  },
  TGO: {
    pais_id: 'TGO',
    pais: 'Togo',
    pais_ingles: 'Togo',
    ddi: 228,
    moeda: 'XOF',
    moeda_nome: 'Franco Cfa Bceão',
    moeda_simbolo: 'Fr',
    sigla_iso: 'TG',
    sigla_idioma: 'FR',
    sigla_fifa: 'TOG',
    tld: '.tg',
    continente: 'AF'
  },
  TKL: {
    pais_id: 'TKL',
    pais: 'Tokelau',
    pais_ingles: 'Tokelau',
    ddi: 690,
    moeda: null,
    moeda_nome: 'New Zealand Dollar',
    moeda_simbolo: null,
    sigla_iso: 'TK',
    sigla_idioma: null,
    sigla_fifa: 'TKL',
    tld: '.tk',
    continente: 'OC'
  },
  TON: {
    pais_id: 'TON',
    pais: 'Tonga',
    pais_ingles: 'Tonga',
    ddi: 676,
    moeda: 'TOP',
    moeda_nome: "Pa'anga",
    moeda_simbolo: 'T$',
    sigla_iso: 'TO',
    sigla_idioma: 'EN',
    sigla_fifa: 'TGA',
    tld: '.to',
    continente: 'OC'
  },
  TTO: {
    pais_id: 'TTO',
    pais: 'Trindade e Tobago',
    pais_ingles: 'Trinidad and Tobago',
    ddi: 868,
    moeda: 'TTD',
    moeda_nome: 'Trinidad and Tobago Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'TT',
    sigla_idioma: null,
    sigla_fifa: 'TRI',
    tld: '.tt',
    continente: 'NA'
  },
  TUN: {
    pais_id: 'TUN',
    pais: 'Tunísia',
    pais_ingles: 'Tunisia',
    ddi: 216,
    moeda: 'TND',
    moeda_nome: 'Tunisian Dinar',
    moeda_simbolo: 'DT',
    sigla_iso: 'TN',
    sigla_idioma: 'AR',
    sigla_fifa: 'TUN',
    tld: '.tn',
    continente: 'AF'
  },
  TKM: {
    pais_id: 'TKM',
    pais: 'Turcomenistão',
    pais_ingles: 'Turkmenistan',
    ddi: 993,
    moeda: 'TMT',
    moeda_nome: 'Turkmenistan New Manat',
    moeda_simbolo: 'm',
    sigla_iso: 'TM',
    sigla_idioma: null,
    sigla_fifa: 'TKM',
    tld: '.tm',
    continente: 'AS'
  },
  TCA: {
    pais_id: 'TCA',
    pais: 'Turks e Caicos',
    pais_ingles: 'Turks and Caicos Islands',
    ddi: 1,
    moeda: 'USD',
    moeda_nome: 'US Dollar',
    moeda_simbolo: '$',
    sigla_iso: 'TC',
    sigla_idioma: null,
    sigla_fifa: 'TCA',
    tld: '.tc',
    continente: 'NA'
  },
  TUR: {
    pais_id: 'TUR',
    pais: 'Turquia',
    pais_ingles: 'Turkey',
    ddi: 90,
    moeda: 'TRY',
    moeda_nome: 'Turkish Lira',
    moeda_simbolo: null,
    sigla_iso: 'TR',
    sigla_idioma: 'TR',
    sigla_fifa: 'TUR',
    tld: '.tr',
    continente: 'AS'
  },
  TUV: {
    pais_id: 'TUV',
    pais: 'Tuvalu',
    pais_ingles: 'Tuvalu',
    ddi: 688,
    moeda: 'AUD',
    moeda_nome: 'Dolar Australiano',
    moeda_simbolo: 'AU$',
    sigla_iso: 'TV',
    sigla_idioma: 'EN',
    sigla_fifa: 'TUV',
    tld: '.tv',
    continente: 'OC'
  },
  UKR: {
    pais_id: 'UKR',
    pais: 'Ucrânia',
    pais_ingles: 'Ukraine',
    ddi: 380,
    moeda: 'UAH',
    moeda_nome: 'Hryvnia',
    moeda_simbolo: '₴',
    sigla_iso: 'UA',
    sigla_idioma: 'RU',
    sigla_fifa: 'UKR',
    tld: '.ua',
    continente: 'EU'
  },
  UGA: {
    pais_id: 'UGA',
    pais: 'Uganda',
    pais_ingles: 'Uganda',
    ddi: 256,
    moeda: 'UGX',
    moeda_nome: 'Uganda Shilling',
    moeda_simbolo: 'Sh',
    sigla_iso: 'UG',
    sigla_idioma: 'EN',
    sigla_fifa: 'UGA',
    tld: '.ug',
    continente: 'AF'
  },
  URY: {
    pais_id: 'URY',
    pais: 'Uruguai',
    pais_ingles: 'Uruguay',
    ddi: 598,
    moeda: 'UYU',
    moeda_nome: 'Peso Uruguayo',
    moeda_simbolo: '$',
    sigla_iso: 'UY',
    sigla_idioma: 'ES',
    sigla_fifa: 'URU',
    tld: '.uy',
    continente: 'SA'
  },
  UZB: {
    pais_id: 'UZB',
    pais: 'Uzbequistão',
    pais_ingles: 'Uzbekistan',
    ddi: 998,
    moeda: 'UZS',
    moeda_nome: 'Uzbekistan Sum',
    moeda_simbolo: null,
    sigla_iso: 'UZ',
    sigla_idioma: null,
    sigla_fifa: 'UZB',
    tld: '.uz',
    continente: 'AS'
  },
  VUT: {
    pais_id: 'VUT',
    pais: 'Vanuatu',
    pais_ingles: 'Vanuatu',
    ddi: 678,
    moeda: 'VUV',
    moeda_nome: 'Vatu',
    moeda_simbolo: 'Vt',
    sigla_iso: 'VU',
    sigla_idioma: 'EN',
    sigla_fifa: 'VAN',
    tld: '.vu',
    continente: 'OC'
  },
  VAT: {
    pais_id: 'VAT',
    pais: 'Vaticano',
    pais_ingles: 'Vatican City State (Holy See)',
    ddi: 379,
    moeda: null,
    moeda_nome: 'Euro',
    moeda_simbolo: '€',
    sigla_iso: 'VA',
    sigla_idioma: 'IT',
    sigla_fifa: 'VAT',
    tld: '.va',
    continente: 'EU'
  },
  VEN: {
    pais_id: 'VEN',
    pais: 'Venezuela',
    pais_ingles: 'Venezuela',
    ddi: 58,
    moeda: 'VEF',
    moeda_nome: 'Bolivar',
    moeda_simbolo: 'Bs F',
    sigla_iso: 'VE',
    sigla_idioma: 'ES',
    sigla_fifa: 'VEN',
    tld: '.ve',
    continente: 'SA'
  },
  VNM: {
    pais_id: 'VNM',
    pais: 'Vietnam',
    pais_ingles: 'Vietnam',
    ddi: 84,
    moeda: 'VND',
    moeda_nome: 'Dong',
    moeda_simbolo: '₫',
    sigla_iso: 'VN',
    sigla_idioma: 'VI',
    sigla_fifa: 'VIE',
    tld: '.vn',
    continente: 'AS'
  },
  WLF: {
    pais_id: 'WLF',
    pais: 'Wallis e Futuna',
    pais_ingles: 'Wallis and Futuna Islands',
    ddi: 681,
    moeda: null,
    moeda_nome: 'CFP Franc',
    moeda_simbolo: null,
    sigla_iso: 'WF',
    sigla_idioma: null,
    sigla_fifa: 'WLF',
    tld: '.wf',
    continente: 'OC'
  },
  YEM: {
    pais_id: 'YEM',
    pais: 'Yemen',
    pais_ingles: 'Yemen',
    ddi: 967,
    moeda: 'YER',
    moeda_nome: 'Yemeni Rial',
    moeda_simbolo: '﷼',
    sigla_iso: 'YE',
    sigla_idioma: null,
    sigla_fifa: 'YEM',
    tld: '.ye',
    continente: 'AS'
  },
  ZMB: {
    pais_id: 'ZMB',
    pais: 'Zâmbia',
    pais_ingles: 'Zambia',
    ddi: 260,
    moeda: 'ZMW',
    moeda_nome: 'Zambian Kwacha',
    moeda_simbolo: 'ZK',
    sigla_iso: 'ZM',
    sigla_idioma: 'EN',
    sigla_fifa: 'ZAM',
    tld: '.zm',
    continente: 'AF'
  },
  ZWE: {
    pais_id: 'ZWE',
    pais: 'Zimbábue',
    pais_ingles: 'Zimbabwe',
    ddi: 263,
    moeda: 'BWP',
    moeda_nome: 'Zimbabwe Dollar',
    moeda_simbolo: 'P',
    sigla_iso: 'ZW',
    sigla_idioma: 'EN',
    sigla_fifa: 'ZIM',
    tld: '.zw',
    continente: 'AF'
  }
};

export default PAISES;
